import $ from 'jquery';

// Make jQuery available globally
window.$ = window.jQuery = $;

export default $;
